import React, { useState } from 'react';
import { supabase } from '../../../lib/supabase';
import Icon from '../../../components/AppIcon';

const DeleteConfirmModal = ({ book, onClose, onDeleted }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    try {
      const { error: deleteError } = await supabase?.from('ebooks')?.delete()?.eq('id', book?.id);
      if (deleteError) throw new Error(deleteError.message);
      onDeleted(book?.id);
    } catch (err) {
      setError(err?.message || 'Failed to delete book.');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card border border-border rounded-xl shadow-xl w-full max-w-md p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Trash2" size={18} color="#ef4444" />
          </div>
          <div>
            <h3 className="text-base font-heading font-semibold text-foreground">Remove Book</h3>
            <p className="text-sm text-muted-foreground">This action cannot be undone.</p>
          </div>
        </div>

        <p className="text-sm text-foreground mb-5">
          Are you sure you want to remove <strong>&ldquo;{book?.title}&rdquo;</strong> from the catalog?
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 border border-border rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className="flex-1 py-2.5 bg-red-500 text-white rounded-lg text-sm font-medium hover:bg-red-600 transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading ? (
              <><Icon name="Loader2" size={16} className="animate-spin" /> Removing...</>
            ) : (
              <><Icon name="Trash2" size={16} /> Remove Book</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
